/**
 * SchemaAttribute Normalizr Schema
 */

import { schema } from 'normalizr';

const schemaAttribute = new schema.Entity('schemaAttributes');

export default schemaAttribute;
